import React from 'react';
import { BrowserRouter, Navigate, Routes as ReactRoutes, Route } from 'react-router-dom';

import { Paths } from '@/routes/paths/Paths';
import { Home } from '@/pages/home/Home';
import { MenuPage } from '@/features/menu/pages/MenuPage';
import { PublicationWallDevPage } from '@/pages/dev/PublicationWallDevPage';
import { ClassificationWallDevPage } from '@/pages/dev/ClassificationWallDevPage';
import { SummaryOverview } from '@/features/summary';
import { ScheduleContent } from '@/features/scheduler/pages/create/ScheduleContent';
import { ListScheduledContent } from '@/features/scheduler/pages/list/ListScheduledContent';
import { PagesProvider } from '@/core/contexts/PagesContext';
import { Header } from '@/features/header/pages/Header';
import { Layout } from '@/core/components/Layout/Layout';
import { GlobalFilterModal } from '@/features/global-filter/components/GlobalFilterModal';
import { GlobalFilterApp } from '@/features/global-filter/GlobalFilterApp';
import { AccountManagerApp } from '@/features/account-manager/AccountManagerApp';
import { CentralApp } from '@/features/central';
import { NewSetupApp } from '@/features/new-setup';
import { MetricsSideBar } from '@/features/metrics-menu/components/MetricsSideBar/MetricsSideBar';

interface RoutesProps {
  ownerIdentity: string;
}

const Routes: React.FC<RoutesProps> = () => {
  return (
    <BrowserRouter>
      <ReactRoutes>
        <Route path={Paths.home} element={<Home />} />
        <Route
          path={Paths.createScheduledContent}
          element={
            <PagesProvider channel="facebook_instagram">
              <ScheduleContent />
            </PagesProvider>
          }
        />
        <Route
          path={Paths.listScheduledContent}
          element={
            <PagesProvider channel="facebook_instagram">
              <ListScheduledContent />
            </PagesProvider>
          }
        />
        <Route
          path={Paths.menu}
          element={<MenuPage />}
        />
        <Route
          path={Paths.publicationWall}
          element={<PublicationWallDevPage />}
        />
        <Route
          path={Paths.classification}
          element={<ClassificationWallDevPage />}
        />
        <Route
          path={Paths.overview}
          element={<SummaryOverview />}
        />
        <Route
          path={Paths.header}
          element={<><Header /><GlobalFilterApp /></>}
        />
        <Route
          path={Paths.headerMenu}
          element={<Layout />}
        />
        <Route
          path={Paths.globalFilter}
          element={<GlobalFilterModal />}
        />
        <Route
          path={Paths.accountManager}
          element={<AccountManagerApp />}
          />
        <Route
          path={Paths.central}
          element={<CentralApp />}
        />
        <Route
          path={Paths.newSetup}
          element={<NewSetupApp />}
        />
        <Route
          path={Paths.metricsMenu}
          element={<MetricsSideBar />}
        />
        <Route path="/*" element={<Navigate to={Paths.home} />} />

      </ReactRoutes>
    </BrowserRouter>
  );
};

export default Routes;
